module.exports = __webpack_public_path__ + "static/40-949076ffe6c74cc1f897db5815880bcb.jpg";